import { LinkResolver } from "@/components/creators/link-resolver";
import type { ResolvedProgram } from "@/lib/queries/projects";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

export const Route = createFileRoute(
  "/(legacy)/creators/programs/$programId/content/$contentId",
)({
  component: ContentRedirect,
});

function ContentRedirect() {
  const { programId } = Route.useParams();
  const navigate = useNavigate();

  const handleResolved = useCallback(
    (data: ResolvedProgram) => {
      const submitContent = data.interactions.find(
        (i) => i.taskType === "SUBMIT_CONTENT",
      );

      if (submitContent) {
        void navigate({
          to: "/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId",
          params: {
            orgSlug: data.orgSlug,
            profileSlug: data.profileSlug,
            campaignId: String(data.campaignId),
            interactionId: String(submitContent.id),
          },
          replace: true,
        });
      } else {
        void navigate({
          to: "/o/$orgSlug/p/$profileSlug/c/$campaignId",
          params: {
            orgSlug: data.orgSlug,
            profileSlug: data.profileSlug,
            campaignId: String(data.campaignId),
          },
          replace: true,
        });
      }
    },
    [navigate],
  );

  return (
    <LinkResolver programId={Number(programId)} onResolved={handleResolved} />
  );
}
